import { deriveAgentBaseUrl, isProductionHost } from "./hostEnvironment";
import { DEFAULT_THEME, parseTheme } from "./theme";

/**
 * Single point of contact for startup config — `import.meta.env`, the Vite `define`d
 * `__VERSION__`, and the launch URL. Nothing else in the app should read them directly.
 *
 * Exception by design: `index.html` re-parses `?theme=` in a tiny inline script so the theme is
 * applied before first paint. React mounts only after an async `bootstrap()`, which would leave a
 * light flash on dark-mode loads. Keep the two in agreement.
 */
const hostname = window.location.hostname;

export const config = {
  agentBaseUrl: deriveAgentBaseUrl(hostname) ?? import.meta.env.VITE_AGENT_BASE_URL,
  isProduction: isProductionHost(hostname),
  appVersion: __VERSION__,
  /** Host-supplied initial theme; the host may later change it over the bridge. */
  theme: parseTheme(new URLSearchParams(window.location.search).get("theme")) ?? DEFAULT_THEME,
};
